// @ts-nocheck

const wordPressUI = (): void => {
  wp.domReady(() => {
    wp.blocks.unregisterBlockStyle('core/image', 'default');
    wp.blocks.unregisterBlockStyle('core/image', 'rounded');
  });
};

export default wordPressUI;
